import { lazy } from "react";
import { FlaskConical } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

export const simulatorFeature: FeatureDescriptor = {
  id: "simulator",
  flag: "simulator",
  path: "/simulator",
  group: "admin",
  navKey: "nav.simulator",
  icon: FlaskConical,
  roles: ["admin"],
  element: lazy(() => import("./SimulatorPage")),
};
